import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import MainRoutes from './pages/MainRoutes';
import { GlobalStyle } from './styles/global';
import { ThemeProvider } from 'styled-components';
import theme from './styles/theme';
import {MuiTheme} from './styles/muiTheme';
import { StyledEngineProvider } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline'; 

function App() {
    const queryClient = new QueryClient();
    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <StyledEngineProvider injectFirst>
                    <MuiThemeProvider theme={MuiTheme}>
                    <CssBaseline />
                    <GlobalStyle />
                    <ThemeProvider theme={theme}>
                        <MainRoutes />
                    </ThemeProvider>
                    </MuiThemeProvider>
                </StyledEngineProvider>
            </BrowserRouter>
        </QueryClientProvider>
    );
}

export default App;

